import { zoomToPoint } from "../../../../MapStore2/web/client/actions/map";
import { calculateFeatureCenter } from "../../../common/util/FeatureCenter";
import { GEOCALC_GEOMETRY_LOADED } from "../loadVisualisedGeoCalculation";
import { CENTER_MAP_TO_GEOCALCULATION, CenterMapOnGeoCalculationAction } from "./centerMapOnGeoCalculation.action";
import { doNothingAction } from "../../../common/action/doNothingAction";
import { EpicFactory } from "../../../core/core-redux/reduxTypes";
import { Action } from "redux";
import { RootState } from "../../../rootState";
import { LoadVisualisedGeoCalculationAction } from "../loadVisualisedGeoCalculation";
import GeoCalculationItem from "../../dto/GeoCalculationItem";
import { Feature } from "../../../core/geo/types";

export const centerMapOnGeoCalculationEpic: EpicFactory<Action, RootState, Action> = (action, store) =>
    action
        .ofType<LoadVisualisedGeoCalculationAction | CenterMapOnGeoCalculationAction>(
            GEOCALC_GEOMETRY_LOADED,
            CENTER_MAP_TO_GEOCALCULATION
        )
        .map((action) => {
            const state = store.getState();

            let features;
            if (action.type === CENTER_MAP_TO_GEOCALCULATION) {
                features = state.geoCalcList.featureLayer?.features[0].features.filter(
                    (calculation) => calculation.calculationId === action.calculationId
                );
            } else if (action.geoCalculations) {
                features = action.geoCalculations.reduce(
                    (acc: Feature[], calc: GeoCalculationItem) => acc.concat(calc.geometry!.features),
                    []
                );
            } else {
                throw new Error("geoCalculations is undefined");
            }

            if (features && features.length > 0) {
                const mapPresent = store.getState().map?.present;
                const calculation = calculateFeatureCenter(features as Feature[], mapPresent);

                return zoomToPoint(calculation.center, calculation.zoom, mapPresent!.projection);
            }

            return doNothingAction();
        });
